import { getRequest, postRequest, logRequest } from './api'

export async function list(size, index, searchTerm, orderBy) {
  logRequest("Show Contracts")
  return getRequest(`contract/get-list/${size || 15}/${index || 0}/${searchTerm || '%20'}/${orderBy || '%20'}`)
}

export async function find(id) {
  logRequest("Show Contract", JSON.stringify(id))
  return getRequest(`contract/edit/${id}`)
}

export async function save(values) {
  logRequest("Save Contract")
  return postRequest(`contract/save`, values)
}

export function remove(values) {
  logRequest("Delete Customer", JSON.stringify(values.values))
  return postRequest(`contract/delete`, values)
}

export async function createContract(id) {
  logRequest("Create Contract From Offer", JSON.stringify(id))
  return getRequest(`contract/create-from-offer/${id}`)
}
 